import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/common/routes/requireAuth'
import { useOrganization } from '@/pages/organizations/detail'
import { useDocbuilder } from '@/pages/organizations/detail/builder'
import Docbuilder from '@/features/docbuilders/components/Docbuilder'

export const Route = createFileRoute('/app/organizations/$organizationId/builder/$docbuilderSlug/$format/')({
  beforeLoad: ({ context }) => {
    requireAuth(context)
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { docbuilderSlug, format } = Route.useParams()
  const { organization } = useOrganization()
  const {
    userCanViewDocbuilders,
    userCanEditDocbuilders,
    userCanUnsubmitAllDocbuilderDocs,
  } = useDocbuilder()

  return (
    <Docbuilder
      docbuilderSlug={docbuilderSlug}
      format={format as 'build' | 'preview'}
      organization={organization}
      userCanViewDocbuilders={userCanViewDocbuilders}
      userCanEditDocbuilders={userCanEditDocbuilders}
      userCanUnsubmitAllDocbuilderDocs={userCanUnsubmitAllDocbuilderDocs}
    />
  )
}
